import {
  STATUS_FAIL,
  STATUS_SUCCESS,
  SYSTEM_ERROR,
  SAVED_LISTS_PAGE_PATH,
  SAVED_LISTS_FORM_NAME
} from '@app/components/common/analytics/analyticsConstants';

const displayFormContentValues = ({ itemPartNumber, startDate, endDate }) => {
  return `Item: ${itemPartNumber} |  Date:${startDate} ${endDate}`;
};
export const getFormSubmitEvent = ({
  formContent,
  formContent2,
  formStatus,
  formFieldCausingError
}) => {
  return {
    event: 'formSubmitted',
    pagePath: SAVED_LISTS_PAGE_PATH,
    formName: SAVED_LISTS_FORM_NAME,
    formContent: formContent,
    formContent2: formContent2,
    formStatus: formStatus,
    formFieldCausingError: formFieldCausingError,
    formLocation: ''
  };
};
export const getSearchResultsFormEvent = ({
  savedListsLength,
  itemPartNumber,
  startDate,
  endDate
}) => {
  return getFormSubmitEvent({
    formContent: displayFormContentValues({
      itemPartNumber,
      startDate,
      endDate
    }),
    formContent2: `Results:${savedListsLength}`,
    formStatus: STATUS_SUCCESS,
    formFieldCausingError: ''
  });
};

export const gaSearchValidationError = ({
  itemPartNumber,
  startDate,
  endDate
}) => {
  return getFormSubmitEvent({
    formContent: displayFormContentValues({
      itemPartNumber,
      startDate,
      endDate
    }),
    formContent2: '',
    formStatus: STATUS_FAIL,
    formFieldCausingError: SYSTEM_ERROR
  });
};
